import { createAction } from 'typesafe-actions';
import { AuthorizationResponse, AuthorizationSigninPayload } from 'types/dto';

export enum AuthAction {
  Clear = 'AUTH_CLEAR',
  Error = 'AUTH_ERROR',
  Request = 'AUTH_REQUEST',
  Response = 'AUTH_RESPONSE',
  Success = 'AUTH_SUCCESS',
}

export const authClear = createAction(AuthAction.Clear)();
export const authError = createAction(AuthAction.Error)<Error>();
export const authRequest = createAction(AuthAction.Request)<AuthorizationSigninPayload>();
export const authResponse = createAction(AuthAction.Response)<AuthorizationResponse>();
export const authSuccess = createAction(AuthAction.Success)();
